export const colors = {
  primary:   "#47657f",  // Noir profond
  primaryDark:   "#2d3f4eff",  // Noir profond
  secondary: "#d8482a",  // Doré/Champagne
  hover:    "#d8482a",  // Orange cuivré (logo)
  white:     "#FFFFFF",
  surface:   "#F5F5F5",
  muted:     "#A5A5A5",
};
